module.exports = __webpack_public_path__ + "static/leah-solivan-0fe49f322e45deff7ef0335e8274021a.jpg";